<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mal-text mt-1 custom-title">QHLS Faculty Meet</h3>
        </div>
    </div>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-3" v-if="!loading && list.length === 0">
        <h3 class="text-center mt-2 text-primary">No faculty meets found</h3>
    </div>
    <div class="section pb-2" v-if="!loading">
        <router-link
            v-for="meet in list"
            :key="meet.response_id"
            :to="'/qhls-faculty-meet/' + meet.meeting_id"
            class="meet-card"
        >
            <div class="meet-card-header">
                <div class="meet-name">{{ meet.name }}</div>
                <span class="meet-status" :class="statusClass(meet.attendance)">{{ statusLabel(meet.attendance) }}</span>
            </div>
            <div class="meet-meta">{{ formatTime(meet.meeting_time) }}</div>
            <div class="meet-meta" v-if="meet.place">{{ meet.place }}</div>
        </router-link>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "QHLSFacultyMeetList",
    components: {
        AlertModel,
    },
    data() {
        return {
            loading: false,
            alert_type: "",
            alert_message: "",
            list: [],
        };
    },
    mounted() {
        if (!this.$store.state.auth.user) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("QHLS Faculty Meet");
        this.getMeets();
    },
    methods: {
        statusLabel(status) {
            if (status === "P") return "Present";
            if (status === "L") return "Leave";
            return "Not Responded";
        },
        statusClass(status) {
            if (status === "P") return "status-present";
            if (status === "L") return "status-leave";
            return "status-pending";
        },
        formatTime(iso) {
            if (!iso) return "";
            const d = new Date(iso);
            return d.toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        getMeets() {
            this.loading = true;
            UserService.authPostRequest("get-my-qhls-faculty-meets", {}).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.list = response.data.data.list || [];
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = "Error";
                    this.alert_message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>

<style scoped>
.meet-card {
    display: block;
    background: #fff;
    border-radius: 10px;
    padding: 12px 14px;
    margin-top: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    text-decoration: none;
}

.meet-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.meet-name {
    font-weight: 600;
    font-size: 14px;
    color: #1f2937;
}

.meet-meta {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
}

.meet-status {
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 12px;
    white-space: nowrap;
}

.status-present {
    background: #dcfce7;
    color: #15803d;
}

.status-leave {
    background: #fee2e2;
    color: #b91c1c;
}

.status-pending {
    background: #fef3c7;
    color: #b45309;
}
</style>
